"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const icons_1 = __importDefault(require("constants/icons"));
const ModalAccountAddresses = ({ addresses, ...rest }) => {
    const renderItem = ({ item, index }) => (<native_base_1.VStack>
			{index != 0 && <native_base_1.View w="100%" h="1" bg="colorLightGray1" mt="15"/>}

			<native_base_1.Text color="colorDarkGray1" mt="15" mx="15">
				{theme_1.Str.address + " " + (index + 1)}
			</native_base_1.Text>
			<native_base_1.HStack alignItems="center" mx="15">
				<native_base_1.Image source={icons_1.default.icMarker} w="15" h="15"/>
				<native_base_1.Text py={2} flex="1" ml="10" variant="body4">
					{item.direccion ?? ""}
				</native_base_1.Text>
			</native_base_1.HStack>
		</native_base_1.VStack>);
    return (<native_base_1.Modal {...rest}>
			<native_base_1.Modal.Content>
				<native_base_1.Modal.CloseButton />
				<native_base_1.Modal.Header>{theme_1.Str.deliveryAddresses}</native_base_1.Modal.Header>
				<native_base_1.Modal.Body>
					<native_base_1.FlatList data={addresses} renderItem={renderItem}/>
				</native_base_1.Modal.Body>
				<native_base_1.Modal.Footer></native_base_1.Modal.Footer>
			</native_base_1.Modal.Content>
		</native_base_1.Modal>);
};
exports.default = ModalAccountAddresses;
